// code generated by `script:genMeta` - DO NOT EDIT
export const version = 'v4.0.0';
export const versionCode = 'Iseri Nina';
export const date = 1719855009686;
